import error_messages from "./error-messages";

/** Construct the OTP Page */
const createEmailSentDiv = () => {
  const mainDiv = document.createElement("div");
  mainDiv.className = "email-sent-content";

  const emailSentDiv = document.createElement("div");
  emailSentDiv.className = "email-otp-div";
  const emailSentHeader = document.createElement("h1");
  const emailSentMsg = document.createElement("p");
  emailSentHeader.textContent = "Email has been sent";
  const user_email = document.getElementById("user_email").value;
  emailSentMsg.textContent = `We've sent a link to ${user_email} to reset your password. Please check your inbox. It could take up to 10 minutes to show up in your inbox.`;
  emailSentMsg.classList.add("email-sent-msg");
  emailSentHeader.classList.add("pswd-help-h1");
  emailSentDiv.appendChild(emailSentHeader);
  emailSentDiv.appendChild(emailSentMsg);
  mainDiv.appendChild(emailSentDiv);

  const otpDiv = document.createElement("div");
  otpDiv.className = "otp-form-content";
  const otpHeader = document.createElement("div");
  otpHeader.className = "otp-header";
  otpHeader.textContent = "OTP Authentication - Please enter OTP";

  const otpForm = document.createElement("div");
  otpForm.className = "otp-form";
  const otpFormLabel = document.createElement("label");
  otpFormLabel.textContent = "OTP";
  otpFormLabel.for = "otp";
  otpFormLabel.id = "otp-label";

  const inputDiv = document.createElement("div");
  inputDiv.className = "otp-input-div";
  const otpInput = document.createElement("input");
  otpInput.className = "otp-input";
  otpInput.id = "otp";
  otpInput.type = "text";
  otpInput.autocomplete = "new-password";
  otpInput.name = "otp";
  otpInput.required = "true";
  otpInput.ariaRequired = "true";

  const otp_error = document.createElement("p");
  otp_error.className = "input-error-msg";
  otp_error.id = "otp-error-msg";

  inputDiv.appendChild(otpInput);
  inputDiv.appendChild(otp_error);
  otpForm.appendChild(otpFormLabel);
  otpForm.appendChild(inputDiv);

  const buttonDiv = document.createElement("div");
  buttonDiv.className = "otp-button-div";
  const submitButton = document.createElement("button");
  submitButton.className = "otp-button";
  submitButton.textContent = "Submit";
  submitButton.id = "otp-submit-button";
  const resendButton = document.createElement("button");
  resendButton.className = "otp-button";
  resendButton.textContent = "Resend OTP";
  resendButton.id = "otp-resend-button";
  buttonDiv.appendChild(submitButton);
  buttonDiv.appendChild(resendButton);

  otpDiv.appendChild(otpHeader);
  otpDiv.appendChild(otpForm);
  otpDiv.appendChild(buttonDiv);

  mainDiv.appendChild(otpDiv);

  return mainDiv;
};

/** Construct the Reset Password Page */
const createResetPswdForm = () => {
  const formDiv = document.createElement("div");
  formDiv.className = "pswd-help-content";

  const errorBanner = document.createElement("div");
  errorBanner.id = "pswd-reset-error-banner";
  formDiv.appendChild(errorBanner);

  const resetPswdHeader = document.createElement("h1");
  const resetPswdTxt = document.createElement("p");
  resetPswdHeader.textContent = "Reset Password";
  const user_email = document.getElementById("user_email").value;
  resetPswdTxt.textContent = `Create a new password for ${user_email}`;
  resetPswdHeader.className = "pswd-help-h1";
  resetPswdTxt.className = "pswd-help-p";
  formDiv.appendChild(resetPswdHeader);
  formDiv.appendChild(resetPswdTxt);

  const new_pswd_label = document.createElement("label");
  new_pswd_label.textContent = "New Password";
  new_pswd_label.for = "new_pswd";
  new_pswd_label.id = "new-pswd-label";

  const newPassword_input = document.createElement("input");
  newPassword_input.id = "new_pswd";
  newPassword_input.type = "password";
  newPassword_input.autocomplete = "new-password";
  newPassword_input.name = "new_pswd";
  newPassword_input.required = "true";
  newPassword_input.ariaRequired = "true";

  const new_pswd_error_msg = document.createElement("p");
  new_pswd_error_msg.className = "input-error-msg";
  new_pswd_error_msg.id = "new-pswd-error-msg";

  formDiv.appendChild(new_pswd_label);
  formDiv.appendChild(newPassword_input);
  formDiv.appendChild(new_pswd_error_msg);

  const confirm_pswd_label = document.createElement("label");
  confirm_pswd_label.textContent = "Confirm Password";
  confirm_pswd_label.for = "confirm_pswd";
  confirm_pswd_label.id = "confirm-pswd-label";

  const confirmPassword_input = document.createElement("input");
  confirmPassword_input.id = "confirm_pswd";
  confirmPassword_input.type = "password";
  confirmPassword_input.autocomplete = "new-password";
  confirmPassword_input.name = "confirm_pswd";
  confirmPassword_input.required = "true";
  confirmPassword_input.ariaRequired = "true";

  const confirm_pswd_error_msg = document.createElement("p");
  confirm_pswd_error_msg.className = "input-error-msg";
  confirm_pswd_error_msg.id = "confirm-pswd-error-msg";

  const pswd_policy = document.createElement("p");
  pswd_policy.className = "pswd-policy";
  pswd_policy.textContent = error_messages.PSWD_POLICY;
  formDiv.appendChild(confirm_pswd_label);
  formDiv.appendChild(confirmPassword_input);
  formDiv.appendChild(confirm_pswd_error_msg);
  formDiv.appendChild(pswd_policy);

  const save_button = document.createElement("button");
  save_button.className = "pswd-help-button";
  save_button.textContent = "Save change and sign in";
  save_button.id = "create-pswd-button";

  formDiv.appendChild(save_button);
  return formDiv;
};

export { createEmailSentDiv, createResetPswdForm };
